import { routes } from 'router';

export const leisurePurchaseSteps = [
  {
    slug: 'summary',
    path: routes.leisurePurchase.children.summary.path,
    order: 0,
    completed: false,
    valid: false,
    current: true
  },
  {
    slug: 'shipping',
    path: routes.leisurePurchase.children.shipping.path,
    order: 1,
    completed: false,
    valid: false,
    current: false
  },
  {
    slug: 'validation',
    path: routes.leisurePurchase.children.validation.path,
    order: 2,
    completed: false,
    valid: false,
    current: false
  },
  {
    slug: 'payment',
    path: routes.leisurePurchase.children.payment.path,
    order: 3,
    completed: false,
    valid: false,
    current: false
  }
];

export const leisureFormDefaultValues = {
  summary: {
    shippingMethod: null
  },
  shipping: {
    civility: '',
    firstname: '',
    lastname: '',
    street: '',
    complement1: '',
    complement2: '',
    postalCode: '',
    city: ''
  },
  validation: {
    subventionChoice: 'withoutSubvention',
    subventionAmount: null,
    subventionValid: false,
    depositChoice: null,
    paymentMethod: null,
    newsletter: false,
    salesTerms: false,
    specificSalesTerms: false,
    cancellationAgreement: false,
    cancellationClauseAccepted: false
  }
};
